import UpcomingRides from './UpcomingRides';

export default UpcomingRides;
